import React, { useEffect, useState } from "react";
import PartnerProfile from "../../../../community/profile/partner_profile.jsx";
import { useDispatch, useSelector } from "react-redux";
import { update_comments_orders } from "../../../../order/orders/actions.js";

const ModeVideosInstruct3 = ({ datajoptiktok }) => {
    const dispatch = useDispatch();
    const comments_orders = useSelector(state => state.comments_orders);
    const [show_example, setshow_example] = useState(false);
    const [showPartnerInfo, setShowPartnerInfo] = useState(false);
    const set_comments_orders = (value) => {
        dispatch(update_comments_orders(value));
    };

    useEffect(() => {
        setShowPartnerInfo(false);
        setshow_example(false);
        set_comments_orders('');
    }, [datajoptiktok]);

    if (!datajoptiktok) return null;

    return (
        <div className="mb-1">
            <div className="text-center">
                {datajoptiktok.category.includes('web_search') && (
                    <>
                        <div
                            className="px-4 py-2 text-base rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition"
                            onClick={() => setshow_example(!show_example)}
                        >
                            ▶️ Videos hướng dẫn
                        </div>
                        {show_example && (
                            <div className="flex text-center">
                                <div className="mx-auto">
                                    <video
                                        src="https://hust.media/media/videos/videos_home/IMG_4772.mp4"
                                        controls
                                        className="mx-auto max-w-full h-auto max-h-[400px]"
                                    >
                                        Trình duyệt của bạn không hỗ trợ thẻ video.
                                    </video>
                                </div>
                            </div>
                        )}
                    </>
                )}
                {datajoptiktok.category.includes('box_shares') && (
                    <>
                        <div
                            className="px-4 py-2 text-base rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition"
                            onClick={() => setshow_example(!show_example)}
                        >
                            ▶️ Videos hướng dẫn
                        </div>
                        {show_example && (
                            <div className="flex text-center">
                                <div className="mx-auto">
                                    <video
                                        src="https://hust.media/img/videos/share_zalo.mp4"
                                        controls
                                        className="mx-auto max-w-full h-auto max-h-[400px]"
                                    >
                                        Trình duyệt của bạn không hỗ trợ thẻ video.
                                    </video>
                                </div>
                            </div>
                        )}
                    </>
                )}
                {datajoptiktok?.category?.includes('tik_cmts_ref') && (
                    <p className="text-center">
                        <a
                            href="https://www.youtube.com/watch?v=F2N2A7zNynY"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="px-4 py-2 text-base rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition">
                                ▶️ Videos hướng dẫn
                            </button>
                        </a>
                    </p>
                )}
                {datajoptiktok?.category?.includes('fb_posts') && (
                    <p className="text-center">
                        <a
                            href="https://www.youtube.com/watch?v=So4hwodlxyc"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="px-4 py-2 text-base rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition">
                                ▶️ Videos hướng dẫn
                            </button>
                        </a>
                    </p>
                )}
                {datajoptiktok?.category?.includes('p2p_mmo') && (
                    <div className="text-center">
                        <div className="mb-2">
                            <input
                                type="text"
                                className="w-full rounded-md border border-blue-200 px-3 py-2 text-base"
                                placeholder="Nhập ghi chú cho người thuê..."
                                value={comments_orders}
                                onChange={(e) => set_comments_orders(e.target.value)}
                            />
                        </div>
                        <a
                            href="https://www.youtube.com/watch?v=So4hwodlxyc"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="px-4 py-2 text-base rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition">
                                ▶️ Videos hướng dẫn
                            </button>
                        </a>
                        {datajoptiktok.partner_usersname && (
                            <button
                                type="button"
                                onClick={() => setShowPartnerInfo((prev) => !prev)}
                                className="ml-2 px-4 py-2 text-base rounded-lg bg-white text-blue-600 border border-blue-200 hover:bg-blue-50 transition"
                            >
                                {showPartnerInfo ? "▶️ Thông tin x" : "▶️ Thông tin người thuê"}
                            </button>
                        )}
                        {showPartnerInfo && datajoptiktok.partner_usersname && (
                            <div className="mt-3">
                                <PartnerProfile partnerUsername={datajoptiktok.partner_usersname} />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ModeVideosInstruct3;
